import { render, staticRenderFns } from "./ServiceDetailTabsIncidences.vue?vue&type=template&id=af27173a&scoped=true&"
import script from "./ServiceDetailTabsIncidences.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsIncidences.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsIncidences.vue?vue&type=style&index=0&id=af27173a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af27173a",
  null
  
)

export default component.exports